import {NgModule} from '@angular/core';
import {AccordionModule} from 'primeng/accordion';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DatePickerModule} from 'primeng/datepicker';
import {DividerModule} from 'primeng/divider';
import {FloatLabelModule} from 'primeng/floatlabel';
import {InputGroupModule} from 'primeng/inputgroup';
import {InputGroupAddonModule} from 'primeng/inputgroupaddon';
import {InputMaskModule} from 'primeng/inputmask';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputTextModule} from 'primeng/inputtext';
import {Message, MessageModule} from 'primeng/message';
import {MultiSelectModule} from 'primeng/multiselect';
import {PaginatorModule} from 'primeng/paginator';
import {PanelModule} from 'primeng/panel';
import {PasswordModule} from 'primeng/password';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {RadioButtonModule} from 'primeng/radiobutton';
import {SelectModule} from 'primeng/select';
import {SkeletonModule} from 'primeng/skeleton';
import {SplitButtonModule} from 'primeng/splitbutton';
import {TableModule} from 'primeng/table';
import {TabsModule} from 'primeng/tabs';
import {TagModule} from 'primeng/tag';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {ToastModule} from 'primeng/toast';
import {ToggleSwitchModule} from 'primeng/toggleswitch';
import {TooltipModule} from 'primeng/tooltip';
const primeNgModules = [
  InputGroupModule,
  InputGroupAddonModule,
  ButtonModule,
  InputTextModule,
  FloatLabelModule,
  PasswordModule,
  InputNumberModule,
  MultiSelectModule,
  SelectModule,
  InputMaskModule,
  CheckboxModule,

  ToggleSwitchModule,
  RadioButtonModule,
  DividerModule,
  TabsModule,
  TagModule,
  CardModule,
  SplitButtonModule,
  MessageModule,
  ToastModule,
  Message,
  PaginatorModule,
  DatePickerModule,
  ConfirmDialogModule,
  ProgressSpinnerModule,
  TableModule,
  PanelModule,
  AccordionModule,
  AutoCompleteModule,
  TooltipModule,
  TieredMenuModule,
  SkeletonModule,
];
@NgModule({
  declarations: [],
  imports: [...primeNgModules],
  exports: [primeNgModules],
})
export class PrimeNgModule {}
